import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TaskRequestSidenavService } from '../../core/services/task-request-sidenav.service';
import * as moment from 'moment/moment';
import { ErrorService } from '../../core/services/error.service';
import { V3PickingDataSourceService } from 'src/app/core/data-sources/v3/picking/v3-picking-data-source.service';
import { PickingProductsResponse } from 'src/models/PickingProducts';

@Component({
  selector: 'app-product-picking',
  templateUrl: './product-picking.component.html',
  styleUrls: ['./product-picking.component.scss']
})
export class ProductPickingComponent implements OnInit {

  items = [];
  isLoading = true;
  actualHour;

  constructor(private route: Router,
              private v3PickingDataSource: V3PickingDataSourceService,
              private sidenavService: TaskRequestSidenavService,
              private errorService: ErrorService) { }

  ngOnInit(): void {
    this.update();
  }

  getProducts(): void {
    this.v3PickingDataSource.getPickingProducts().then((values) => {
      this.items = this.buildTableData(values);
      this.isLoading = false;
    }, (error) => {
      this.errorService.openErrorSnackBar(error);
      this.isLoading = false;
    });
  }

  buildTableData(values: PickingProductsResponse) {
    const rows: any[] = [];
    values.forEach(v => {
      v.products.forEach(p => rows.push({
        name: p.name,
        sku: p.sku,
        quantity: p.quantity,
        description: p.description,
        pickingPositions: [{
          id: v.position.id,
          groundPosition: {
            x: v.position.x,
            y: v.position.y,
            z: v.position.z,
            alias: v.position.alias
          },
          createdAt: v.position.createdAt,
          updatedAt: v.position.updatedAt
        }],
        position: v.position
      }));
    });
    return rows;
  }

  async openSidenav(type: string): Promise<void> {
    const data = {
      type,
      products: this.items
    };
    this.sidenavService.toggle(data).then(async (res: any) => {
      this.update();
    });
  }

  update() {
    this.actualHour = moment().format('HH:mm');
    this.getProducts();
  }

  navigateTo(route: string) {
    this.route.navigate([route]);
  }

}
